import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getExportReportAttendanceHost = async (queries = '') => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `attendance-report/host/export?${queries}`, responseType: 'blob' });

  return data;
};

export default getExportReportAttendanceHost;
